import { gql } from '@apollo/client/core';

export const BOOK_LOAD = gql`
    mutation bookLoad($bookLoad: BookLoad!) {
        bookLoad(BookLoad: $bookLoad) {
            Success
            WasEdiTender
            EdiRespondBy
            Load {
                LoadBoardId
                LoadStatus
                CarrierCharges {
                    LoadCarrierCostId
                    ChargeTypeId
                    CostPerUnit
                    Units
                    TotalCost
                    Comment
                    Quantity
                }
                DriverInfo {
                    Driver
                    DriverPhone
                    TrailerNumber
                    TruckNumber
                    SecondDriver
                    SecondDriverPhoneNumber
                }
            }
        }
    }
`;

export const BOOK_LOAD_IS_LOAD_BOARD = gql`
    mutation bookLoad($bookLoad: BookLoad!) {
        bookLoad(BookLoad: $bookLoad) {
            Success
            WasEdiTender
            EdiRespondBy
        }
    }
`;


export const UPDATE_USER_PASSWORD = gql`
    mutation updateUserPassword($newPassword: String, $oldPassword: String) {
        updatePassword(newPassword: $newPassword, oldPassword: $oldPassword)
    }
`;

export const UPDATE_USER_PROFILE = gql`
    mutation updateUserProfile($userProfile: UserProfileInput!) {
        updateUserInfo(userProfile: $userProfile) {
            UserId
            FirstName
            LastName
        }
    }
`;

export const REQUEST_LOCK = gql`
    mutation requestLock($loadNumber: Int!, $durationSeconds: Int!) {
        requestLock(loadNumber: $loadNumber, durationSeconds: $durationSeconds) {
            lockId
            lockDateTime
        }
    }
`;

export const RELEASE_LOCK = gql`
    mutation releaseLock($lockId: Int!, $loadNumber: Int!, $doNotReturnLockToOriginalOwner: Boolean!) {
        releaseLock(lockId: $lockId, loadNumber: $loadNumber, doNotReturnLockToOriginalOwner: $doNotReturnLockToOriginalOwner)
    }
`;

export const CANCEL_OFFER = gql`
    mutation cancelOffer($offerId: Int!, $changeReason: Int) {
        cancelOffer(offerId: $offerId, changeReason: $changeReason) {
            id
            status
            updatedOn
            changeReason
        }
    }
`;

export const MAKE_OFFER = gql`
    mutation makeOffer($offerAmount: Int!, $loadNumber: Int!, $carrierRep: CarrierRep, $emptyDateTime: String, $emptyCity: EmptyCity) {
        makeOffer(offerAmount: $offerAmount, loadNumber: $loadNumber, carrierRep: $carrierRep, emptyDateTime: $emptyDateTime, emptyCity: $emptyCity) {
            id
            amount
            status
            expiration
            updatedOn
            timerStart
            loadNumber
            carrierCode
            carrierName
        }
    }
`;

export const UPDATE_TRUCK_DRIVER = gql`
    mutation updateTruckDriver($driverInfo: UpdateDriverInfo!, $loadNumber: Int!, $emptyTruckInfo: EmptyTruckInfo) {
        updateTruckDriver(DriverInfo: $driverInfo, EmptyTruckInfo: $emptyTruckInfo, LoadNumber: $loadNumber) {
            Success
            Load {
                LoadBoardId
                DriverInfo {
                    Driver
                    SecondDriver
                    DriverPhone
                    SecondDriverPhoneNumber
                    TrailerNumber
                    TruckNumber
                }
                EmptyCityState
                EmptyDateTime
            }
        }
    }
`;

export const CHANGE_STATUS_BOOK_TENDER = gql`
    mutation changeStatusBookTender($loadTenderId: Int, $isLoadUpdated: Boolean, $isAccepted: String!) {
        changeStatusBookTender(loadTenderId: $loadTenderId, isLoadUpdated: $isLoadUpdated, isAccepted: $isAccepted) {
            loadTenderId
            carrierId
            loadNumber
            tenderedDate
            tenderTypeId
            finalCarrierId
            isAccepted
        }
    }
`;

export const BOOK_LOAD_IN_COMMITTED_CAPACITY = gql`
    mutation bookLoadInCommittedCapacity($bookLoad: BookLoadCommittedCapacity!) {
        bookLoadInCommittedCapacity(BookLoad: $bookLoad) {
            Success
            Load {
                LoadBoardId
                LoadStatus
                CarrierCharges {
                    LoadCarrierCostId
                    ChargeTypeId
                    CostPerUnit
                    Units
                    TotalCost
                    Comment
                    Quantity
                }
                DriverInfo {
                    Driver
                    DriverPhone
                    TrailerNumber
                    TruckNumber
                    SecondDriver
                    SecondDriverPhoneNumber
                }
            }
        }
    }
`;

export const MAKE_COUNTER_OFFER = gql`
    mutation makeCounterOffer($offerId: Int!, $counterAmount: Int!) {
        makeCounterOffer(offerId: $offerId, counterAmount: $counterAmount) {
            id
            amount
            status
        }
    }
`;

export const ACCEPT_AND_BOOK_OFFER = gql`
    mutation acceptAndBookOffer($bookLoad: BookLoad!) {
        acceptAndBookOffer(BookLoad: $bookLoad) {
            Success
            Load {
                LoadBoardId
            }
            Offer {
                id
                status
            }
        }
    }
`
export const UPDATE_COMMITMENT_RECIPIENT_EMAILS = gql`
    mutation updateCommitmentEmailRecipients($carrierId: Int!, $rateConEmail: String!, $loadTenderEmail: String!) {
        updateCommitmentEmailRecipients(carrierId: $carrierId, rateConEmail: $rateConEmail, loadTenderEmail: $loadTenderEmail) {
            success
            invalidEmails
        }
    }
`;
export const SAVE_USER_LAST_LOGIN = gql`
    mutation saveUserLastLogin {
        saveUserLastLogin
    }
`;

export const PROCESS_TENDER = gql`
    mutation processTender($loadTenderId: Int, $isAccepted: Boolean) {
        processTender(loadTenderId: $loadTenderId, isAccepted: $isAccepted) {
            loadTenderId
            carrierId
            loadNumber
            tenderedDate
            tenderTypeId
            finalCarrierId
            isAccepted
        }
    }
`

export const SEND_MESSAGE_TO_EVENT_HUB = gql`
  mutation sendMessageToEventHub($message: SendMessageToEventHubType!) {
    sendMessageToEventHub(message: $message) {
      Success
      Message
    }
  }
`;
